import React from 'react';
import { withRouter } from 'react-router-dom';
import { observer, inject } from 'mobx-react';
import { withTranslation } from 'react-i18next';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { ContainerBox, Table, ModalFooter } from 'components';
import { PROFILE_ROLES_PREFIX, MODAL_ID, STORAGE_KEYS, DATE_FORMAT, NO_DATE } from '../../core/utils/constants';
import { ReactNotifications } from "../../core/logic";
import BaseComponent from '../BaseComponent';
import ScreenTeamAddUser from './ScreenTeamAddUser';
import ScreenChangeTeamName from './ScreenChangeTeamName';
import moment from 'moment';
import './style.scss';

const TABLE_ROW_WIDTH_MODEL = {
  NO: "6%",
  USER_ID: "33%",
  USER_NAME: "30%",
  USER_LEVEL: "24%",
  REMOVE: "5%",
};
const TABLE_ROW_WIDTH_APITOKEN = {
  NO: "6%",
  TOKEN: "40%",
  COMMENT: "30%",
  CREATED_AT: "18%",
};

@inject('commonStore', 'modalStore')
@observer
class ScreenEditTeam extends BaseComponent {
  teamId = null;
  tenantId = null;
  constructor(props) {
    super(props);
    this.state = {
      teamName: '',
      selectedIndexTab: 0,
    }
    this.teamId = this.props.match.params?.id;
  }

  executeLogicAfterRender = async () => {
    this.props.commonStore.teamStore.clean();
    await this.getTeamInfo();
    await this.props.commonStore.apiTokenStore.getTeamTokens(this.teamId, this.tenantId);
  }

  executeOnDidUpdate = async (prevProps) => {
    if (prevProps.match.params.tenantId !== this.props.match.params.tenantId) {
      await this.getTeamInfo();
    }
  }

  executeLogicBeforeOutComponent = () => {
    this.props.commonStore.teamStore.clean();
  }

  getTeamInfo = async () => {
    this.tenantId = this.props.match.params?.tenantId ? this.props.match.params?.tenantId : null;
    if (this.tenantId !== null) {
      await this.props.commonStore.teamStore.getTenantInfo(this.tenantId);
      await this.props.commonStore.teamStore.getTenantTeamById(this.tenantId, this.teamId);
    } else {
      await this.props.commonStore.teamStore.cleanTenantInfo();
      await this.props.commonStore.teamStore.getTeamById(this.teamId);
    }
  }

  openChangeTeamNameModal = () => {
    const { modalStore, t } = this.props;
    modalStore.show({
      id: MODAL_ID.UPDATE_TEAM,
      isOpen: true,
      header: t('team.modal_team_management_title'),
      onCancel: this.closeModal,
      children: (
        <ScreenChangeTeamName
          saveButtonText={t('definition.save')}
          teamName={this.props.commonStore.teamStore.teamName}
          teamId={this.teamId}
          tenantId={this.tenantId}
        />
      )
    });
  };

  onConfirmDeleteById = (sequence) => {
    const { commonStore: { teamStore } } = this.props;
    let payload = {
      id: this.teamId,
      sequence: sequence
    }
    if (this.tenantId !== null) {
      payload["tenantId"] = this.tenantId;
      teamStore.deleteTenantUserForTeam(
        payload,
        () => {
          this.getTeamInfo();
          this.closeModal();
        }
      );
    } else {
      teamStore.deleteUserForTeam(
        payload,
        () => {
          this.getTeamInfo();
          this.closeModal();
        }
      );
    }
  }

  trHandler = () => {
    // compute for table body
    let table = document.getElementsByClassName("tbl-edit-team") || document.getElementsByClassName("tbl-edit-api");
    if (table && table[0]) {
      let tableHead = window.$(".tbl-edit-team table thead");
      if (tableHead && tableHead[0]) {
        let tableBody = window.$(".tbl-edit-team table tbody");
        if (tableBody && tableBody[0]) {
          let tableBodyHeight = table[0].offsetHeight - tableHead[0].offsetHeight;

          // compute tr
          let trElements = window.$(".tbl-edit-team table tbody tr");
          let trHeight = 0;
          let num = 0;
          for (let i = 0; i < trElements.length; i++) {
            if (num !== 0) {
              trHeight += trElements[i].offsetHeight;
            }
            num++;
          }

          if (tableBodyHeight > trHeight) {
            tableHead[0].style.overflowY = "hidden";
          } else {
            tableHead[0].style.overflowY = "scroll";
          }
        }
      }
    }
  }

  openComfirmDeleteModal = (sequence) => {
    const { modalStore, t } = this.props;
    modalStore.show({
      id: MODAL_ID.REMOVE,
      isOpen: true,
      header: t('definition.remove_confirm'),
      onCancel: this.closeModal,
      children: (
        <div className="text-c">
          <div key={"modal-body"} className="modal-body">
            <span>{t('team.remove_user_confirm_msg')}</span>
          </div>
          <ModalFooter key={"modal-footer"}
            saveButtonText={t('team.remove')}
            onConfirm={() => this.onConfirmDeleteById(sequence)}
            cancelButtonText={t('definition.cancel')}
            onCancel={this.closeModal}
            saveButtonClass="btn-primary"
          />
        </div>
      ),
      type: 'small'
    });
  };

  openAddUserModal = () => {
    const { t, modalStore } = this.props;
    modalStore.show({
      id: MODAL_ID.UPDATE_TEAM_ADD_USER,
      isOpen: true,
      header: `${t('team.modal_add_user_title')}`,
      onCancel: this.closeModal,
      children: (
        <ScreenTeamAddUser
          teamId={this.teamId}
          tenantId={this.tenantId}
        />
      ),
      type: "big"
    });
  };

  closeModal = () => {
    const { modalStore } = this.props;
    modalStore.hideAll();
  };

  onFetch = (tableData) => {
    this.props.commonStore.teamStore.updatePagingFiler(tableData);
    this.getTeamInfo();
  };

  handleBack = () => {
    this.props.history.push("/tenant/" + this.tenantId + "/teams");
  };

  handleSelectTab = index => {
    this.setState({ selectedIndexTab: index });
  };

  handleCopy = (str) => {
    const { t } = this.props;
    const el = document.createElement('textarea');
    el.value = str;
    el.setAttribute('readonly', '');
    el.style.position = 'absolute';
    el.style.left = '-9999px';
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
    ReactNotifications("info", t("upload.copy"), "");
  }

  handleGenerate = async () => {
    const { commonStore: { apiTokenStore: { generateTeamToken } } } = this.props;
    await generateTeamToken(this.teamId, this.tenantId);
  }

  onChangeApiToken = (e) => {
    this.apiToken[e.target.name] = e.target.value;
  }

  onConfirmEditApiToken = () => {
    const { commonStore: { apiTokenStore } } = this.props;
    const payload = {
      id: this.apiToken.id,
      comment: this.apiToken.comment,
    }
    apiTokenStore.updateTeamToken(payload, this.tenantId);
    this.closeModal();
  }

  openEditTokenModal = (apiToken) => {
    const { modalStore, t } = this.props;
    this.apiToken = JSON.parse(JSON.stringify(apiToken));

    modalStore.show({
      id: MODAL_ID.UPDATE_API_TOKEN,
      isOpen: true,
      header: t('api_token.modal.edit.page_title'),
      onCancel: this.closeModal,
      children: (
        <div className="text-c">
          <div key={"modal-body"} className="modal-body modal-add-item">
            <div className="row" style={{ paddingTop: "15px" }}>
              <div className="col-sm-1" />
              <div className="col-sm-4 font-bold">{t("api_token.modal.edit.token")}</div>
              <div className="col-sm-6" id="div_item_name">
                {this.apiToken.raw_token ? this.apiToken.raw_token : `team_********-****-****-****-********${this.apiToken.token_suffix}`}
              </div>
            </div>
            <div className="row" style={{ paddingTop: "15px" }}>
              <div className="col-sm-1" />
              <div className="col-sm-4 font-bold">{t("api_token.modal.edit.comment")}</div>
              <div className="col-sm-6" id="div_item_name">
                <input name="comment"
                  type="text"
                  maxLength={255}
                  onChange={(e) => this.onChangeApiToken(e)}
                  defaultValue={this.apiToken.comment}
                />
              </div>
            </div>
          </div>

          <ModalFooter key={"modal-footer"}
            saveButtonText={t('common.save')}
            onConfirm={this.onConfirmEditApiToken}
            saveButtonClass="btn-primary"
          />
        </div>
      ),
      type: 'medium'
    });
  };

  onConfirmRemoveApiToken = (id) => {
    const { commonStore: { apiTokenStore } } = this.props;
    apiTokenStore.deleteTeamToken(id, this.tenantId);
    this.closeModal();
  }

  openDeleteTokenModal = (id) => {
    const { modalStore, t } = this.props;
    modalStore.show({
      id: MODAL_ID.REMOVE,
      isOpen: true,
      header: t('api_token.modal.delete.page_title'),
      onCancel: this.closeModal,
      children: (
        <div className="text-c">
          <div key={"modal-body"} className="modal-body">
            <span>{t('api_token.modal.delete.confirm_msg')}</span>
          </div>
          <ModalFooter key={"modal-footer"}
            saveButtonText={t('common.remove')}
            onConfirm={() => this.onConfirmRemoveApiToken(id)}
            cancelButtonText={t('common.cancel')}
            onCancel={this.closeModal}
            saveButtonClass="btn-primary"
          />
        </div>
      ),
      type: 'small'
    });
  };

  apiTokenColumn = () => {
    const { t } = this.props;
    return [
      {
        Header: t("common.no"),
        disableSortBy: true,
        width: TABLE_ROW_WIDTH_APITOKEN.NO,
        Cell: ({ row }) => <div style={{ textAlign: "center" }}>{row.index + 1}</div>
      },
      {
        Header: t('api_token.table.token'),
        accessor: 'apiToken',
        Cell: ({ row: { original } }) => {
          return (
            <div className="color-theme cursor-p">
              <span onClick={() => this.openEditTokenModal(original)}>{original.raw_token ? original.raw_token : `team_********-****-****-****-********${original.token_suffix}`}</span>
              {original.raw_token && <i className="fa fa-files-o" style={{ marginLeft: "12px" }} onClick={() => this.handleCopy(original.raw_token)}></i>}
            </div>
          );
        },
        width: TABLE_ROW_WIDTH_APITOKEN.TOKEN
      },
      {
        Header: t('api_token.table.comment'),
        accessor: 'comment',
        Cell: ({ row: { original } }) => {
          return (
            <div className="color-theme cursor-p" onClick={() => this.openEditTokenModal(original)}>
              {original.comment}
            </div>
          );
        },
        width: TABLE_ROW_WIDTH_APITOKEN.COMMENT
      },
      {
        Header: t('common.created_date'),
        accessor: 'createdAt',
        Cell: ({ row: { original } }) => {
          return (
            <div>
              {original.created_at ? moment(original.created_at).format(DATE_FORMAT.full_time) : NO_DATE}
            </div>
          );
        },
        width: TABLE_ROW_WIDTH_APITOKEN.CREATED_AT
      },
      {
        Header: '',
        id: 'remove',
        className: 'admin-action',
        Cell: ({ row: { original: { id } } }) => {
          return <div>
            <button className="btn btn-danger" type="button" onClick={() => this.openDeleteTokenModal(id)}>
              {t('common.remove')}
            </button>
          </div>
        },
        width: 100,
      }
    ];
  }

  render() {
    const { t, commonStore: { teamStore: { paging, tenantInfo }, apiTokenStore: { apiTokens } } } = this.props;
    const teamName = this.props.commonStore.teamStore.teamName || "";
    const teamUsers = this.props.commonStore.teamStore.teamUsers || [];
    const columns = [
      {
        Header: t("team.no"),
        disableSortBy: true,
        width: TABLE_ROW_WIDTH_MODEL.NO,
        Cell: ({ initialState, row }) => <div style={{ textAlign: "center" }}>{
          initialState?.initialTableState?.pageSize *
          initialState?.initialTableState?.pageIndex +
          row.index +
          1
        }</div>
        ,
      },
      {
        Header: t('team.user_id'),
        accessor: 'userId',
        Cell: ({ row: { original } }) => {
          return (
            <div>
              {original.userId}
            </div>
          );
        },
        width: TABLE_ROW_WIDTH_MODEL.USER_ID
      },
      {
        Header: t('team.user_name'),
        accessor: 'userName',
        Cell: ({ row: { original } }) => {
          return (
            <div>
              {original.userName}
            </div>
          );
        },
        width: TABLE_ROW_WIDTH_MODEL.USER_NAME
      },
      {
        Header: t('team.user_level'),
        accessor: 'role',
        Cell: ({ row: { original } }) => {
          return (
            <div>
              {t(PROFILE_ROLES_PREFIX + original.role)}
            </div>
          );
        },
        width: TABLE_ROW_WIDTH_MODEL.USER_LEVEL
      },
      {
        Header: '',
        id: 'action',
        className: 'admin-action',
        Cell: ({ row: { original: { sequence } } }) => {
          return <div>
            <button className="btn btn-danger" type="button" onClick={() => this.openComfirmDeleteModal(sequence)}>
              {t('team.remove')}
            </button>
          </div>
        },
        width: 100,
      }
    ];

    let contractorName = "";
    if (this.tenantId !== null) {
      contractorName = tenantInfo ? tenantInfo.name : "";
    } else {
      if (localStorage.getItem(STORAGE_KEYS.USER_INFO)) {
        let userInfo = JSON.parse(localStorage.getItem(STORAGE_KEYS.USER_INFO));
        contractorName = userInfo.tenantName;
      }
    }

    return (
      <div className="screen-team">
        <ContainerBox headerTitle={`${t('team.page_edit_team_title')}`}>
          <div className="admin-header-container">
            <div className="col-sm-9">
              <div className="row">
                <div className="col-sm-4" style={{ textAlign: "left", fontWeight: "bold" }}>
                  {t("team.contractor")}
                </div>
                <div className="col-sm-8" style={{ textAlign: "left" }}>
                  {contractorName}
                </div>
              </div>
              <div className="row">
                <div className="col-sm-4" style={{ textAlign: "left", fontWeight: "bold" }}>
                  {t("team.team_name")}
                </div>
                <div className="col-sm-8" style={{ textAlign: "left" }}>
                  {teamName}
                </div>
              </div>
            </div>
            <div className="col-sm-3" style={{ textAlign: "right" }}>
              {
                this.tenantId &&
                <button
                  className="btn btn-primary"
                  type="button"
                  onClick={this.handleBack}
                >
                  {t("team.handle_back")}
                </button>
              }
              <button
                className="btn btn-primary"
                type="button"
                style={{ marginLeft: "10px" }}
                onClick={this.openChangeTeamNameModal}
              >
                {t("team.change")}
              </button>
            </div>
          </div>
        </ContainerBox>

        <ContainerBox type="basic" className="admin-body-container-edit table-container">
          <Tabs selectedIndex={this.state.selectedIndexTab} onSelect={this.handleSelectTab}>
            <TabList>
              <Tab>{t("team.edit.tab.user")}</Tab>
              <Tab>{t("team.edit.tab.api")}</Tab>
            </TabList>

            {/* 一般タブ */}
            <TabPanel>
              <div className="box-body document-item-info tab-user">
                <button
                  className="btn btn-primary team-btn-style f-r mb-3"
                  type="button"
                  onClick={this.openAddUserModal}>
                  {t("team.add_user")}
                </button>
                <Table
                  className="tbl-edit-team"
                  columns={columns}
                  data={teamUsers}
                  disablePaging={false}
                  onFetch={this.onFetch}
                  enableServerSidePaging={true}
                  initialTableState={paging}
                />
              </div>
            </TabPanel>

            {/* APIタブ */}
            <TabPanel>
              <div className="box-body document-item-info tab-api">
                <button className="btn btn-primary team-btn-style mb-3" onClick={this.handleGenerate}>
                  {t("api_token.generate")}
                </button>
                {
                  apiTokens && apiTokens.length > 0 &&
                  <Table
                    columns={this.apiTokenColumn()}
                    data={apiTokens}
                    disablePaging={true}
                    disableSelectionPageSize={true}
                    enableServerSidePaging={false}
                    hideTableFooter={true}
                    className="tbl-edit-api"
                  />
                }
              </div>
            </TabPanel>
          </Tabs>
        </ContainerBox>
      </div >
    );
  }

}

export default withRouter(withTranslation()(ScreenEditTeam));
